// ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Imports
// ----------------------------------------------------------------------------
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Libraries
import React from "react";
// import PropTypes from 'prop-types';
import { css } from "glamor";
import { Tabs } from "antd";
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Components

import { Elements } from "@bodhi-project/typography";
import { Images } from "@bodhi-project/components";

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Locals
import DefaultSection from "../components/DefaultSection";

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Abstractions
const { H1, H3 } = Elements;
const TabPane = Tabs.TabPane;

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ import json file
// const data = require('./recent-titles.json');

// ----------------------------------------------------------------------------
// ------------------------------------------------------------------ Functions
// ----------------------------------------------------------------------------

// ----------------------------------------------------------------------------
// --------------------------------------------------------------------- Styles
// ----------------------------------------------------------------------------
const blockStyle = css({
  minHeight: "calc(80vh - 70px)",
  backgound: "transparent",
  display: "flex",
  alignItems: "center",
  alignContent: "center",
  paddingTop: "8vh",
  paddingBottom: "12vh"
});

const blockStyleClass = blockStyle.toString();

// ----------------------------------------------------------------------------
// ------------------------------------------------------------------ Component
// ----------------------------------------------------------------------------
/** InfoTabs */
class InfoTabs extends React.Component {
  /** standard constructor */
  constructor(props) {
    super(props);
  }

  /** standard renderer */
  render() {
    return (
      <DefaultSection className={blockStyleClass}>
        <div>
          <H1 style={{ color: "#FFFFFF" }}>
            Digital infrastructure for document security.
          </H1>
        </div>
        <div className="card-container">
          <Tabs type="card">
            <TabPane tab="Publishers & Retailers" key="1">
              <p style={{ color: "#FFFFFF" }}>
                1. Protect your digital publications.
              </p>
              <p style={{ color: "#FFFFFF" }}>
                2. Sell under secured DRM from your own website.
              </p>
              <p style={{ color: "#FFFFFF" }}>
                3. Sell directly to End-users or lend to Libraries.
              </p>
            </TabPane>
            <TabPane tab="Customized Retail System" key="2">
              <p style={{ color: "#FFFFFF" }}>
                1. Adopt powerful retail application developed by DMR.
              </p>
              <p style={{ color: "#FFFFFF" }}>
                2. Configurable to your brand and payment gateway.
              </p>
              <p style={{ color: "#FFFFFF" }}>
                3. Seamlessly integrated with DMR Application.
              </p>
            </TabPane>
            <TabPane tab="Institutions" key="3">
              <p style={{ color: "#FFFFFF" }}>
                1. Secure sensitive digital documnets organization wide.
              </p>
              <p style={{ color: "#FFFFFF" }}>
                2. Documents render only on recepients' authorized devices.
              </p>
              <p style={{ color: "#FFFFFF" }}>
                3. Seamlessly integrated with in-house document generation and
                sharing network.
              </p>
            </TabPane>
          </Tabs>
        </div>
      </DefaultSection>
    );
  }
}

// ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Exports
// ----------------------------------------------------------------------------
export default InfoTabs;



// WEBPACK FOOTER //
// ./src/blocks/InfoTabs.jsx